import React, { ReactElement } from 'react';
import { Flex, HStack } from '@cad-arc';
import { PanelTitle } from '../../panels/panel-title';
import { UnitHistoryForm } from '../types';
import { sortTypeOptions } from '../constants';
import { SortMenu } from '../components/sort-menu';
import { FrPageHeader } from '../../fr-page-layout/fr-page-header';
import { UnitHistoryMoreActionsMenu } from '../components/unit-history-more-actions-menu';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function UnitHistoryHeader(): ReactElement {
    const { form } = useIntegratedForm<UnitHistoryForm>();
    const sortTypeOption = form.watch('sortTypeOption');
    const { isFirstResponder } = useApplicationType();

    const commonContent = (
        <HStack alignItems="center" flexShrink={0}>
            <SortMenu
                value={sortTypeOption}
                onChange={(value) => form.setValue('sortTypeOption', value)}
                options={sortTypeOptions}
            />
            <UnitHistoryMoreActionsMenu />
        </HStack>
    );

    if (isFirstResponder) {
        return (
            <FrPageHeader title="Unit History" customStyles={{ justifyContent: 'space-between' }}>
                {commonContent}
            </FrPageHeader>
        );
    }

    return (
        <Flex justifyContent="space-between" alignItems="center" width="100%">
            <PanelTitle>Unit History</PanelTitle>
            {commonContent}
        </Flex>
    );
}
